export default __webpack_public_path__ + "static/media/logo_totem.8d64c0fb.png";